import Shared from '../services/Shared'
import Store from '../../redux/Store' //can only import useDispatch in components
import { setError } from '../../redux/ApiSlice'

const Api = {

    baseUrl: 'https://henry-salazar.net:8081',
    origin: 'https://henry-salazar.net:81',
    
    //baseUrl: 'http://localhost:8081',
    //origin: 'http://localhost',

    // Could use modern libraries Axios or React Query / RTK Query instead
    fetch_: function (url, onSuccess, body, method, headers, onError, tryRefreshToken = true) {

        let token = sessionStorage.getItem(Shared.key.token);

        if (window.location.href.includes("canine-u/")) { //if not home

            //if not logged in
            const user = sessionStorage.getItem(Shared.key.user);
            if (!token || !user) {

                //redirect
                console.log("unauthorized. redirecting to login");
                window.location.href = this.origin + Shared.path.login;
                return;
            }
        }

        if (!method) {
            method = body ? "POST" : "GET";
        }

        if (!headers) {
            headers = {
                "Content-type": "application/json; charset=UTF-8"
            }
            if (token) {
                headers.Authorization = "Bearer " + token;
            }
        }

        let options = {
            mode: 'cors',
            method,
            headers,
            ...(body && { body: JSON.stringify(body) }) //omit body if not present
        }

        fetch(url, options).then(response => {
            if (!response.ok) {

                //token expired
                if (response.status === 401) {

                    if (!tryRefreshToken) {
                        onError && onError(response);
                        return;
                    }

                    console.log("token expired");

                    //refresh token
                    const refreshToken = sessionStorage.getItem(Shared.key.refresh);
                    if (refreshToken) {

                        //recursive call
                        this.postRefresh(refreshToken, resp => {

                            console.log("refreshed token successfully");
                            sessionStorage.setItem(Shared.key.token, resp.token);

                            //recursive call
                            this.fetch_(url, onSuccess, body, method, headers, false);
                            return;

                        }, () => {
                            console.log("refresh token expired or other issue");
                            sessionStorage.removeItem(Shared.key.refresh);
                            window.location.href = this.origin + Shared.path.login;
                            return;
                        });
                    }
                    else {
                        console.log("missing refresh token");
                        window.location.href = this.origin + Shared.path.login;
                        return;
                    }
                }
                else {
                    throw response;
                }
            }
            else if (method === "DELETE") {
                onSuccess && onSuccess();
            }
            else {
                response.json().then(data => {
                    onSuccess && onSuccess(data);
                });
            }
        })
        .catch(error => {
            console.log('api error');
            console.log(error);

            if (error.status) {
                error.text().then(text => {
                    try {
                        const parsed = JSON.parse(text);
                        Store.dispatch(setError({ message: parsed.message || `HTTP ${error.status}` }));
                    } catch {
                        Store.dispatch(setError({ message: text || `HTTP ${error.status}` }));
                    }
                });
            }
            else {
                Store.dispatch(setError({ message: error.toString() }));
            }

            onError && onError(error);
            return;
        });
    },

    deleteSchedule: function (id, onSuccess) {

        this.fetch_(this.baseUrl + '/schedules/' + id, onSuccess, null, "DELETE");
    },

    getClassesBy: function (courseId, semester, days, onSuccess) {

        let url = this.baseUrl + '/classes?courseId=' + courseId;
        if (semester) {
            url += '&semester=' + semester;
        }
        if (days) {
            url += '&days=' + days;
        }

        this.fetch_(url, onSuccess);
    },

    getCoursesBySubject: function (subject, onSuccess) {

        this.fetch_(this.baseUrl + '/courses?subject=' + subject, onSuccess);
    },

    getDays: function (onSuccess) {

        this.fetch_(this.baseUrl + '/classes/days', onSuccess);
    },

    getFaculty: function (onSuccess) {

        this.fetch_(this.baseUrl + '/faculty/all', onSuccess);
    },

    getSchedule: function (semester, onSuccess) {

        this.fetch_(this.baseUrl + '/schedules?semester=' + semester, onSuccess);
    },

    getSchedulePdf: function (semester, onSuccess) {

        this.fetch_(this.baseUrl + '/schedules/pdfs?semester=' + semester, onSuccess);
    },

    getSubjects: function (onSuccess) {

        this.fetch_(this.baseUrl + '/courses/subjects', onSuccess);
    },

    getUser: function (onSuccess) {

        this.fetch_(this.baseUrl + '/users', onSuccess);
    },

    postSchedule: function (schedule, onSuccess) {

        this.fetch_(this.baseUrl + '/schedules', onSuccess, schedule);
    },

    postRefresh: function (refreshToken, onSuccess, onError) {

        this.fetch_(this.baseUrl + '/tokens/refresh', onSuccess, {
            refreshToken: refreshToken
        }, null, null, onError);
    },

    postToken: function (email, password, onSuccess) {

        this.fetch_(this.baseUrl + '/tokens', onSuccess, {
            email: email,
            password: password
        }, null, null, response => {
            if (response.status === 401) {
                Store.dispatch(setError({ message: "Invalid credentials" }));
            }
        }, false);
    }
};

export default Api;